

import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        success: {
            verificationOnly: "SheerID handles verification only. Now that you've been approved, please direct all questions about the promotion terms and/or code use to <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a> customer service.",
        },
        error: {
            redirectButtonText: 'CONTINUE TO TIMBERLAND',
        },
    },
};
